import request from '@/utils/request'

export function activateCard(password, exam_year) {
    return request({
        url: '/web/vip/newActivateCard',
        method: 'post',
        data: {
            password: password,
            exam_year: exam_year,
        }
    })
}

export function checkActivate() {
    return request({
        url: '/web/vip/check_activate',
        method: 'post',
        data: {
        }
    })
}

export function checkVip() {
    return request({
        url: '/web/vip/newCheckVip',
        method: 'post',
        data: {
        }
    })
}

export function cardType(password) {
    return request({
        url: '/web/user/card_type',
        method: 'post',
        data: {
            password: password
        }
    })
}